import gsap from "gsap";
import * as PIXI from "pixi.js";
import { fruitData } from "./data";
import { tweenPulsate } from "./utility";

export class Meter {
    meterContainer = null;
    meterHolder = [];
    blockSize = null;
    topPos = 697;
    heart = null
    heartText = null;
    meterMask = null;
    meterFruitContainer = null;
    fruit = null;

    multipliers = {
        2: [0.5, 10],
        3: [0.5, 10],
        4: [0.5, 10],
        5: [0.5, 20],
        6: [0.5, 3, 20],
        7: [0.5, 5, 50],
        8: [0.5, 2, 5, 75],
        9: [0.5, 3, 15, 100],
        10: [0.5, 1, 5, 20, 150],
        11: [0.5, 2, 5, 25, 500],
        12: [0.5, 1, 2, 5, 25, 1000],
    };

    graphic = {
        4: [0, 0, 2],
        5: [495, -497, 0],
        6: [495, -497, 0],
        7: [495, -497, 0],
        8: [495, -497, 2],
        9: [495, -497, 2],
        10: [495, -497, 3],
        11: [495, -497, 4],
        12: [495, -496, 3],

    }

    positions = {
        4: [1, 2],
        5: [2, 3],
        6: [2, 3, 4],
        7: [3, 4, 5],
        8: [3, 4, 5, 6],
        9: [4, 5, 6, 7],
        10: [4, 5, 6, 7, 8],
        11: [5, 6, 7, 8, 9],
        12: [5, 6, 7, 8, 9, 10]
    }

    meterPos = {
        4: [-140, 116.5, 1],
        5: [-95, 100, 0.8],
        6: [-76, 83.8, 0.7],
        7: [-68, 71, 0.6],
        8: [-60, 61.8, 0.45],
        9: [-45, 56, 0.45],
        10: [-51, 49, 0.45],
        11: [-45, 44.6, 0.45],
        12: [-36, 41.5, 0.45]
    }

    fruitPosition = {
        4: [-80, -190, -312, -425, 0.94],
        5: [-55, -148, -245, -345, -440, 0.79],
        6: [-50, -122, -200, -285, -370, -455, 0.67],
        7: [-50, -113, -180, -243, -315, -385, -455, 0.6],
        8: [-40, -96, -154, -210, -275, -337, -400, -460, 0.5],
        9: [-35, -85, -135, -185, -240, -298, -352, -408, -460, 0.43],
        10: [-33, -80, -127, -175, -220, -270, -320, -370, -420, -465, 0.39],
        11: [-33, -75, -120, -162, -205, -244, -290, -335, -380, -423, -465, 0.36],
        12: [-33, -70, -110, -150, -188, -225, -265, -305, -347, -388, -430, -470, 0.32]

    }

    currentFruit = [];

    multiplierPositions = {
        4: [-277, -320],
        5: [-320, -365],
        6: [-320, -365, -410],
        7: [-365, -410, -455],
        8: [-365, -410, -455, -500],
        9: [-410, -455, -500, -545],
        10: [-410, -457, -500, -547, -590],
        11: [-455, -500, -545, -590, -635],
        12: [-455, -500, -545, -590, -638, -680]
    }

    colorPattern = {
        4: ['white', 'blue'],
        5: ['white', 'purple'],
        6: ['white', 'green', 'purple'],
        7: ['white', 'blue', 'purple'],
        8: ['white', 'green', 'blue', 'purple'],
        9: ['white', 'green', 'purple', 'yellow'],
        10: ['white', 'green', 'blue', 'purple', 'yellow'],
        11: ['white', 'green', 'blue', 'purple', 'yellow'],
        12: ['white', 'green', 'green', 'blue', 'purple', 'yellow']
    }

    constructor() {
        this.meterContainer = new PIXI.Container();
        this.meterContainer.y = -10
        this.meterFruitContainer = new PIXI.Container();
        this.meterFruitContainer.name = "fruit_container"
        this.fruits = [];

        for (let i = 4; i <= 12; i++) {
            this.createMeter(i)
        }

        this.heart = new PIXI.Sprite(PIXI.Assets.get('heart_whole_small'));
        this.heart.anchor.set(0.5);
        this.heart.scale.set(0.45);
        this.heart.position.set(160, -210)
        this.meterContainer.addChild(this.heart);

        this.heartText = new PIXI.Text('6', {
            fontFamily: 'LuckyGuy',
            fontSize: 43,
            align: 'center',
            fill: '#FFFFFF',
            fontWeight: 400,
            letterSpacing: 0
        });
        this.heartText.anchor.set(0.5);
        this.heart.addChild(this.heartText)

    }

    addFruit(fruit) {
        if (Array.isArray(fruit)) {
            this.currentFruit = fruit
        } else {
            this.currentFruit.push(fruit);
        }

        this.meterFruitContainer.removeChildren();

        this.currentFruit.map((value, index) => {
            this.fruit = new PIXI.Sprite(PIXI.Assets.get(`meter_${value}`));
            this.fruit.anchor.set(0.5);
            this.fruit.y = this.fruitPosition[fruitData.totalRounds][index];
            this.fruit.scale.set(0.4, this.fruitPosition[fruitData.totalRounds][this.fruitPosition[fruitData.totalRounds].length - 1])
            this.meterFruitContainer.addChild(this.fruit);
        })

    }

    pulsateHeart(isPulsate) {
        if (isPulsate) {
            const pulsate = this.heartText.text == 0 ? 0.2 : 0.4
            tweenPulsate(this.heart, pulsate, 0.55);
        } else {
            gsap.killTweensOf(this.heart);
            this.heartText.style.fill = '#FFFFFF';
            this.heartText.visible = true;
            this.heart.scale.set(0.45);
            this.heart.texture = PIXI.Assets.get("heart_whole_small");
            if (!fruitData.showWin)
                this.heartText.text = this.multipliers[fruitData.roundSettings[fruitData.roundPointer]].length
            else if (fruitData.showWin && fruitData.winName == 'prizeUpgrade')
                this.heartText.text = 2;
        }
    }

    updateHeart() {
        this.heartText.text = this.heartText.text - 1;

        if (this.heartText.text < 1) {
            this.heartText.visible = false;
            this.pulsateHeart(true);
            this.heart.texture = PIXI.Assets.get("heart_crack_small");
        } else if (this.heartText.text < 2) {
            this.pulsateHeart(true);
            this.heartText.style.fill = '#FFFF00';
        }

    }

    clearMeter() {
        const holder = this.meterHolder[fruitData.totalRounds];
        const fruitContainer = holder.children.find(child => child.name === "fruit_container");

        if (fruitContainer) {
            fruitContainer.destroy({ children: true });
        }

        this.meterFruitContainer = new PIXI.Container();
        this.meterFruitContainer.name = "fruit_container";
    }


    updateMultipliers() {
        const holder = this.meterContainer;
        const multiplierContainer = holder.children.find(child => child.name === "multiplier_container");

        if (!multiplierContainer) return;

        const rounds = fruitData.showWin ? fruitData.totalRounds : fruitData.roundSettings[fruitData.roundPointer];
        const multipliers = this.multipliers[rounds];

        for (let i = 0; i < multipliers.length; i++) {
            const mult = multipliers[i];
            const calculated = fruitData.betSettings[fruitData.betPointer] * mult;

            const textObj = multiplierContainer.children[i];

            if (textObj && textObj instanceof PIXI.BitmapText) {
                textObj.text = `${calculated}`;

                const calcStr = calculated.toString();

                if (calcStr.includes(".") || calcStr.length <= 3) {
                    textObj.anchor.set(0.5);
                    textObj.x = 202;
                } else {
                    textObj.anchor.set(1, 0.5);
                    textObj.x = 230;
                }
            }
        }
    }

    createMultipliers(rounds) {
        const holder = this.meterContainer;
        const existing = holder.children.find(child => child.name === "multiplier_container");


        if (existing) {
            holder.removeChild(existing);
            existing.destroy({ children: true });
        }

        const multiplierContainer = new PIXI.Container();
        multiplierContainer.name = "multiplier_container";

        for (let i = 0; i < this.multipliers[rounds].length; i++) {
            const mult = this.multipliers[rounds][i];
            const calculated = fruitData.betSettings[fruitData.betPointer] * mult;

            const text = new PIXI.BitmapText(`${calculated}`, {
                fontName: `${this.colorPattern[rounds][i]}-font`,
                fontSize: 6,
                align: "center",
                letterSpacing: -18,
            });

            const calcStr = calculated.toString();

            if (calcStr.includes(".") || calcStr.length <= 3) {
                text.anchor.set(0.5);
                text.x = 202;
            } else {
                text.anchor.set(1, 0.5);
                text.x = 230;
            }

            text.y = this.multiplierPositions[rounds][i];

            multiplierContainer.addChild(text);
        }


        multiplierContainer.x = 0;
        multiplierContainer.y = 0;
        this.meterContainer.addChild(multiplierContainer);
    }

    createMeter(i) {
        this.meterHolder[i] = new PIXI.Sprite(PIXI.Assets.get("meter_panel"));
        this.meterHolder[i].anchor.set(0.5, 1);
        this.meterHolder[i].scale.set(1.15);
        this.meterHolder[i].visible = false;
        this.meterHolder[i].position.set(
            200, -160
        );

        if (i > 4) {
            this.tubeMask = new PIXI.Graphics();
            this.tubeMask.beginFill(0x000000);
            const tubeX = 0;
            const tubeY = 0;
            const tubeWidth = 57
            const tubeHeight = this.graphic[i][0];
            const cornerRadius = 18;

            this.tubeMask.drawRoundedRect(tubeX, tubeY, tubeWidth, tubeHeight, cornerRadius);
            this.tubeMask.x = -28;
            this.tubeMask.y = this.graphic[i][1]
            this.meterHolder[i].addChild(this.tubeMask);
            this.tubeMask.endFill();
            this.meterHolder[i].mask = this.tubeMask
        }


        const startY = this.meterPos[i][0];
        let k = 0;
        this.meterContainer.addChild(this.meterHolder[i]);

        this.meterHolder[i].height = i * 46
        this.blockSize = this.meterPos[i][1];

        for (let j = this.positions[i][0]; j <= this.positions[i][this.positions[i].length - 1]; j++) {

            const block = new PIXI.Sprite(PIXI.Assets.get(`meter_lines_${this.colorPattern[i][k]}`));
            block.anchor.set(0.5);
            block.scale.set(0.34, this.meterPos[i][2])

            block.y = startY - j * this.blockSize;

            this.meterHolder[i].addChild(block);

            const pattern = new PIXI.Sprite(PIXI.Assets.get(`meter_color_${this.colorPattern[i][k]}`));
            pattern.anchor.set(0.5, 1);
            pattern.scale.set(0.34, 1)
            pattern.y = block.y

            if (j == this.positions[i][this.positions[i].length - 1]) {
                pattern.height = this.blockSize + this.graphic[i][2];
            }
            else
                pattern.height = this.blockSize;

            this.meterHolder[i].addChild(pattern)
            k++;
        }

    }
}